import React from "react";
import { Modal, Button } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";
import parse from 'html-react-parser';



class PageModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { show, title, description, onClose, onConfirm, closeText, confirmText } = this.props;

        return (
            <Modal backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{title || "Exclusão de registro"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{description ? parse(description) : "Tem certeza que deseja excluir o registro selecionado?"}</Modal.Body>
                <Modal.Footer>
                    {onClose && <CancelButton
                        containerProps={{
                            onClick: onClose
                        }}
                    />}
                    {onConfirm && <Button variant="success" onClick={onConfirm}>
                        {confirmText || "Confirmar"}
                    </Button>}
                </Modal.Footer>
            </Modal>
        );
    };
}

export default PageModal;